<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>分享管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-table :data="userData" style="width: 100%">
      <!-- <el-table-column label="用户 ID" prop="id"> </el-table-column> -->
      <el-table-column label="名称" prop="name"> </el-table-column>
      <el-table-column label="用户" prop="map.userInfo.nick_name"> </el-table-column>
      <el-table-column label="被分享用户" prop="map.shareUserInfo.nick_name"> </el-table-column>
      <el-table-column label="二维码">
        <template slot-scope="scope">
          <img :src="scope.row.qr_code" width="50px" height="50px" alt="" />
        </template>
      </el-table-column>
      <el-table-column label="用户观看时间" prop="click_time"> </el-table-column>
       <el-table-column label="分享用户观看时间" prop="share_click_time"> </el-table-column>
      <el-table-column label="用户分享次数" prop="share_count"> </el-table-column>
        <el-table-column label="分享点击次数" prop="share_click_count"></el-table-column>
        <el-table-column label="是否可分享" >
          <template slot-scope="scope">
          <!-- <el-button type="success" size="mini" @click="oppen(scope.row)"
            >查看权限</el-button
          > -->
          <!-- <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button> -->
          <el-button size="mini" type="text" v-if="scope.row.is_shareable==true"
            >是</el-button
          >
          <el-button size="mini" type="text" v-if="scope.row.is_shareable==false"
            >否</el-button
          >
        </template>
        </el-table-column>

      <el-table-column label="过期时间" prop="expired_time"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="success" size="mini" @click="oppen(scope.row)"
            >查看权限</el-button
          > -->
          <!-- <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button> -->
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum"
      :page-sizes="[1, 2, 5, 10]"
      :page-size="queryInfo.pagesize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 修改 -->
    <el-dialog title="修改" :visible.sync="editShow">
      <el-form :model="editFrom" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editFrom.name"></el-input>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="editFrom.url" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="分享次数">
          <el-input v-model="editFrom.share_count"></el-input>
        </el-form-item>
        <el-form-item label="截止时间">
          <el-date-picker
            v-model="editFrom.expired_time"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <template slot-scope="scope">
            <el-button type="primary" @click="fenxiang1(scope.row)"
              >确定</el-button
            >
            <el-button @click="editShow = false">取消</el-button>
          </template>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import axios1 from "axios";
import Qs from "qs";
export default {
  name: "role",
  data() {
    return {
      addShow: false,
      editShow: false,

      total: 0,
      // 获取用户列表的参数对象
      queryInfo: {
        query: "",
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },

      userData: [],
      rules: {
        type: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },

      addForm: {},
      editFrom: {
        name: "",
        url: "",
        expired_time: "",
        share_count:''
      },
    };
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    //   -----分页------
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getList();
    },
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getList();
    },
    // ----end--------

    // 获取黑名单列表
    getList() {
      this.$fetch(
        "/news/newsShareUrlShared/queryManagerListPage?status=2&pageSize=" +
          this.queryInfo.pagesize +
          "&currentPage=" +
          this.queryInfo.pagenum
      ).then((res) => {
        this.userData = res.data.rows;
        this.total = res.data.total;
        console.log("黑名单", this.userData);
      });
    },
    // 修改
    fenxiang1() {
      this.$post("/news/newsShareUrlShared/update", this.editFrom).then((res2) => {
        console.log(res2.data);
        if (res2.code == 0) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
            this.getList();
          this.editShow = false;
        }
      });
    },
    // 修改
    handleEdit(row) {
      this.editFrom.id = row.id;
      this.editFrom.name = row.name;
      this.editFrom.url = row.url;
      this.editFrom.url_id = row.url_id;
      this.editFrom.expired_time = row.expired_time;
      this.editFrom.status = row.status;
      this.editFrom.share_count =row.share_count;
      this.editShow = true;
    },
    // 删除
    handleDelete(row) {
      // 弹框询问用户是否直接删除数据
      let data = {};
      data.id = row.id;
      data.status = 1;
      this.$confirm("此操作将永久删除该链接, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post("/news/newsShareUrlShared/update", data).then((res) => {
            if (res.code != 0) {
              return this.$message.error("删除链接失败!");
            } else {
              this.getList();
              return this.$message.success("删除链接成功!");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 添加
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post("/news/newsShareUrl/insert", this.addForm).then((res) => {
            console.log(res);
            if (res.code == 0) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.getList();
              this.addShow = false;
              this.addForm = {};
              this.addForm.is_shareable = false;
            } else {
              this.$message({
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.editFrom);
          this.$post("/news/newsShareUrl/update", this.editFrom).then((res) => {
            console.log(res);

            if (res.code == 0) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.getList();
              this.editFrom.menuIds = [];
              this.editShow = false;
            } else {
              this.$message({
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped>
.add {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/guanli/deathList.vue